<template>
  <div
    class="c-dropdown c-dropdown-container"
    v-bind:style="{
      top: posy + offsety + 'px',
      left: posx + offsetx + 'px',
      display: toggled ? 'inline-block' : 'none',
      opacity: show ? 1 : 0,
      width: width,
      height: height,
    }"
    v-bind:class="{
      tooltip: tooltip,
      centered: centered,
      list: type === 'list',
      'list-thick': listStyle,
      expanded: expanded,
      scrolling: scroll,
      'no-scrolling': noScroll,
      'index-override': indexOverride,
      'drag-container': draggable,
      locked: GetLockedStatus(),
      'allow-overflow': allowOverflow,
    }"
  >
    <div
      class="background"
      v-on:scroll="PreventScroll($event)"
      v-on:click="Toggle($event)"
    ></div>
    <div class="container-body">
      <div class="fa-stack cancel" v-on:click="Toggle()" v-if="type !== 'list'">
        <i class="fas fa-circle fa-stack-2x"></i>
        <i class="fas fa-times fa-stack-2x"></i>
      </div>
      <div class="header" v-if="header">
        <div class="label">{{ header }}</div>
      </div>
      <div class="header tab-header" v-if="tabs.length > 0">
        <div
          class="label"
          v-for="(tab, indexT) in tabs"
          :key="'t' + indexT"
          v-bind:class="{ selected: tabCurrent === tab }"
          v-on:click="ChangeTab(tab)"
        >
          {{ tab.tabHeader }}
        </div>
      </div>
      <div class="tab-body">
        <div
          v-if="componentState && type === 'list'"
          class="component items"
          v-bind:class="{ 'icons-left': iconsLeft }"
        >
          <div
            class="item"
            v-for="(item, indexI) in componentState.entries"
            :key="indexI"
            v-bind:class="{ selected: item.selected, header: item.isHeader }"
            v-on:click="SelectItem($event, item)"
            v-bind:style="item.styles"
          >
            <i
              v-if="item.toggled !== undefined && item.toggled"
              class="fas fa-check-circle checkbox true"
              v-bind:style="{ color: item.color }"
            ></i>
            <i
              v-if="item.toggled !== undefined && !item.toggled"
              class="fas fa-circle checkbox false"
              v-bind:style="{ color: item.color }"
            ></i>
            <div class="label">{{ item.label }}</div>
          </div>
        </div>
        <component
          class="component"
          v-if="
            components && components.length > 0 && component.type !== 'list'
          "
          v-for="(component, indexC) in components"
          :key="component.type + indexC"
          v-bind:is="component.type"
          :state="component.state"
          v-bind="component.propContainer"
          ref="component"
          v-on="component.customEvents"
          @click.native="ClickComponent(component)"
          @hook:mounted="Reposition"
        ></component>
      </div>
    </div>
    <div
      class="pointer up"
      v-bind:style="{
        left: pointerOffset + 'px',
        display:
          !pointerHide && pointerDirection === 0 ? 'inline-block' : 'none',
      }"
    ></div>
    <div
      class="pointer right"
      v-bind:style="{
        top: pointerOffset + 'px',
        display:
          !pointerHide && pointerDirection === 1 ? 'inline-block' : 'none',
      }"
    ></div>
    <div
      class="pointer down"
      v-bind:style="{
        left: pointerOffset + 'px',
        display:
          !pointerHide && pointerDirection === 2 ? 'inline-block' : 'none',
      }"
    ></div>
    <div
      class="pointer left"
      v-bind:style="{
        top: pointerOffset + 'px',
        display:
          !pointerHide && pointerDirection === 3 ? 'inline-block' : 'none',
      }"
    ></div>
  </div>
</template>

<script>
import dropdownsearch from "./dropdownsearch.vue";
import imagecrop from "./imagecrop.vue";
import datafill from "./datafill.vue";
import datatable from "./datatable.vue";
//import rosterrequestwizard from '../rostercontext/RosterRequestWizard.vue'
export default {
  name: "dropdowncontainer",
  components: {
    dropdownsearch,
    imagecrop,
    datafill,
    //rosterrequestwizard,

    datatable,
  },
  data() {
    return {
      searchbarItems: {
        items: [],
        input: "",
      },
      el: null,
      elRelative: null,
      defaultSettings: {
        pointerDirection: 0,
        pointerOffset: 15,
      },
      selectedItem: {},
      items: [],
      toggled: false,
      posx: 0,
      posy: 0,
      offsetx: 0,
      offsety: 0,
      remainAfterSelect: false,
      pointerDirection: -1,
      pointerOffset: 15,
      selectCallback: function ($event, item) {},
      parentCallback: function () {},
      currentComponent: "",
      mode: "",
      iconsLeft: false,
      expanded: false,
      eventProp: {},
      header: null,
      show: false,
      componentState: {},
      type: "",
      centered: false,
      width: "",
      height: "",
      scroll: false,
      noScroll: false,
      tabs: [],
      tabCurrent: null,
      customEventName: null,
      customEventHandler: null,
      tooltip: false,
      listStyle: false,
      pointerHide: false,
      indexOverride: false,
      draggable: false,
      callbackDrag: null,
      propContainer: {},
      components: [],
      //components can either be like this
      //{type: 'datafill', state: {...}}
      //or
      //{type: 'labelc', propContainer: {text: '', icon-left: '', ...}}
      //propContainer passes each key as a prop to the component to avoid having to name everything state or have to specify props like eventProp
      //customEvents go in a customEvents object in the component where the key is the name and the value is the handler
      //{type: 'emotlist', customEvents: {'append' : this.AppendUnicode}}
      //click event has to go separate because it won't work if it's not click.native

      //These are used to pin the container to an element
      pinTopRight: false,
      pinTopLeft: false,
      pinBottomRight: false,
      pinBottomLeft: false,
      locked: false,
      allowOverflow: false,
    };
  },
  created() {
    window.addEventListener("resize", this.Reposition);
    var view = this;
    requestAnimationFrame(function () {
      $(view.$el).appendTo("body");
    });
  },
  mounted() {
    if (!this.state) this.toggled = false;
    if (this.draggable) {
      window.removeEventListener("mousemove", this.DragTrack);
      window.addEventListener("mousemove", this.DragTrack);
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.Reposition);
    window.removeEventListener("mousemove", this.DragTrack);
    window.removeEventListener("mouseup", this.CallbackDrag);
  },
  watch: {
    state: {
      immediate: true,
      handler(newVal, oldVal) {
        this.show = false;
        if (!newVal) {
          this.toggled = false;
          return;
        }
        for (var x in newVal) this[x] = newVal[x];
        this.toggled = newVal.hasOwnProperty("toggled") ? newVal.toggled : true;
        if (!this.toggled) return;
        if (this.draggable) {
          window.removeEventListener("mousemove", this.DragTrack);
          window.removeEventListener("mouseup", this.CallbackDrag);
          window.addEventListener("mousemove", this.DragTrack);
          window.addEventListener("mouseup", this.CallbackDrag);
          if (!this.state.offsetx) this.offsetx = 15;
          if (!this.state.offsety) this.offsety = 15;
        }
        if (this.state && this.state.tabs) {
          this.ChangeTab(this.tabs[0]);
        } else {
          if (this.eventProp) {
            if (this.propContainer && !this.propContainer.eventProp)
              this.propContainer.eventProp = this.eventProp;
            if (!this.propContainer)
              this.propContainer = { eventProp: this.eventProp };
          }

          if (!newVal.components) {
            this.components = [];
            if (this.componentState) {
              let component = {
                type: this.type,
                state: this.componentState,
                propContainer: this.propContainer,
                customEvents: {},
              };
              if (this.customEventName) {
                component.customEvents[
                  this.customEventName
                ] = this.HandleCustomEvent;
              }
              this.components.push(component);
            }
          }
        }
        var view = this;

        if (this.type === "list") {
          requestAnimationFrame(function () {
            view.Reposition();
          });
        }
      },
    },
  },
  props: {
    dropdown: Object,
    state: Object,
  },
  methods: {
    GetLockedStatus() {
      if (Object.prototype.toString.call(this.locked) == "[object Function]")
        return this.locked(this);
      return this.locked;
    },
    Close() {
      this.toggled = false;
      window.removeEventListener("mousemove", this.DragTrack);
      window.removeEventListener("mouseup", this.CallbackDrag);
      this.$emit("on-close", this);
    },
    ClickComponent(component) {
      if (component.click) {
        component.click(
          this,
          this.$children[this.components.indexOf(component)]
        );
      }
    },
    DragTrack($event) {
      this.posx = window.mouse.x;
      this.posy = window.mouse.y;
    },
    CallbackDrag() {
      this.$emit("CallbackDrag", window.mouse.element, this);
      if (this.callbackDrag) this.callbackDrag(window.mouse.element, this);
      if (!this.remainAfterSelect) {
        this.$emit("on-close", this);
        this.toggled = false;
      } else {
        window.removeEventListener("mousemove", this.DragTrack);
        window.removeEventListener("mouseup", this.CallbackDrag);
        this.draggable = false;
      }
    },
    ChangeTab(tab) {
      this.tabCurrent = tab;
      if (!tab.components) {
        this.components = [];
        if (tab.componentState) {
          let component = {
            type: tab.type,
            state: tab.componentState,
            propContainer: tab.propContainer,
            customEvents: {},
          };
          if (tab.customEventName) {
            component.customEvents[tab.customEventName] = tab.HandleCustomEvent;
          }
          this.components.push(component);
        }
      } else {
        this.components = tab.components;
      }
    },
    PreventScroll($event) {
      $event.preventDefault();
    },
    Reposition() {
      if (!this.$el) return;
      var boxContainer = this.$el.getBoundingClientRect();
      var view = this;
      if (this.elRelative) {
        if (this.pinTopRight) {
          requestAnimationFrame(function () {
            let boxRelative = view.elRelative.getBoundingClientRect();
            view.posx = boxRelative.right + 1; // + 1 to account for border
            view.posy = boxRelative.top;
            view.$forceUpdate();
          });
        } else if (this.pinTopLeft) {
          requestAnimationFrame(function () {
            let boxRelative = view.elRelative.getBoundingClientRect();
            boxContainer = view.$el.getBoundingClientRect();
            view.posx = boxRelative.left - 1 - boxContainer.width; // + 1 to account for border
            view.posy = boxRelative.top;
            view.$forceUpdate();
          });
        } else if (this.pinBottomRight) {
          requestAnimationFrame(function () {
            let boxRelative = view.elRelative.getBoundingClientRect();
            boxContainer = view.$el.getBoundingClientRect();
            view.posx = boxRelative.right + 1; // + 1 to account for border
            view.posy = boxRelative.bottom + boxContainer.height;
            view.$forceUpdate();
          });
        } else if (this.pinBottomLeft) {
          requestAnimationFrame(function () {
            let boxRelative = view.elRelative.getBoundingClientRect();
            boxContainer = view.$el.getBoundingClientRect();
            view.posx = boxRelative.left - 1 - boxContainer.width; // + 1 to account for border
            view.posy = boxRelative.bottom + boxContainer.height;
            view.$forceUpdate();
          });
        } else if (
          view.pointerDirection === 0 ||
          view.pointerDirection === 1 ||
          view.pointerDirection === 2 ||
          view.pointerDirection === 3
        ) {
          requestAnimationFrame(function () {
            var boxRelative = view.elRelative.getBoundingClientRect();
            var boxPointer = null;
            boxContainer = view.$el.getBoundingClientRect();

            var widthTotal = window.innerWidth;
            var heightTotal = window.innerHeight;
            var posx = 0;
            var posy = 0;
            var widthContainer = boxContainer.width;
            var heightContainer = boxContainer.height;
            var offsetFromPointer = boxContainer.width * 0.5; //15;
            view.pointerHide = false;
            if (view.pointerDirection === 0) {
              boxPointer = $(view.$el)
                .find(".pointer.up")[0]
                .getBoundingClientRect();
              view.pointerOffset =
                boxContainer.width * 0.5 - boxPointer.width * 0.5;
              posx =
                boxRelative.left +
                boxRelative.width * 0.5 -
                boxContainer.width * 0.5;
              var pointerPositionRelative = boxPointer.top - boxContainer.top;
              posy = boxRelative.bottom + 5;
            }
            if (view.pointerDirection === 1) {
              boxPointer = $(view.$el)
                .find(".pointer.right")[0]
                .getBoundingClientRect();
              posx = boxRelative.left - offsetFromPointer - boxContainer.width;
              var pointerPositionRelative = boxPointer.top - boxContainer.top;
              posy =
                boxRelative.top +
                boxRelative.height / 2 -
                pointerPositionRelative;
            }
            if (view.pointerDirection === 2) {
              boxPointer = $(view.$el)
                .find(".pointer.down")[0]
                .getBoundingClientRect();
              posx = boxRelative.right + offsetFromPointer;
              var pointerPositionRelative = boxPointer.top - boxContainer.top;
              posy =
                boxRelative.top +
                boxRelative.height / 2 -
                pointerPositionRelative;
            }
            if (view.pointerDirection === 3) {
              boxPointer = $(view.$el)
                .find(".pointer.left")[0]
                .getBoundingClientRect();
              posx = boxRelative.right + 15;
              if (posx + widthContainer > widthTotal)
                posx = widthTotal - widthContainer;
              var pointerPositionRelative = boxPointer.top - boxContainer.top;
              posy =
                boxRelative.top +
                boxRelative.height * 0.5 -
                boxContainer.height * 0.5 -
                (boxPointer.top +
                  boxPointer.height * 1.5 -
                  (boxPointer.top + boxContainer.height * 0.5));
            }
            if (boxContainer.left + boxContainer.width + posx > widthTotal) {
              console.log("too far right");
              posx = widthTotal - boxContainer.width - 5;
              view.pointerHide = true;
            }
            if (boxContainer.left + posx < 0) {
              console.log("too far left");
              posx = 5;
              view.pointerHide = true;
            }
            if (boxContainer.top + boxContainer.height + posy > heightTotal) {
              console.log("too far down");
              posy = heightTotal - boxContainer.height - 5;
              view.pointerHide = true;
            }
            if (boxContainer.left + posy < 0) {
              console.log("too far up");
              posy = 5;
              view.pointerHide = true;
            }
            view.posx = posx;
            view.posy = posy;
            //view.pointerDirection = pointerDirection;
            view.$forceUpdate();
          });
        } else {
          if (!this.offsetx) this.offsetx = 0;
          if (!this.offsety) this.offsety = 0;
          this.posx = window.mouse.x;
          this.posx +=
            this.pointerDirection === 3 ? -this.offsetx : this.offsetx;
          this.posy = window.mouse.y;
          this.posy +=
            this.pointerDirection === 2 ? -this.offsety : this.offsety;

          if (this.pointerDirection === 3)
            this.posx -= this.$el.getBoundingClientRect().width;
          if (this.pointerDirection === 2)
            this.posy -= this.$el.getBoundingClientRect().height;
        }
      } else {
        if (!this.offsetx) this.offsetx = 10;
        if (!this.offsety) this.offsety = -10;
        this.posx = window.mouse.x;
        this.posx += this.pointerDirection === 3 ? -this.offsetx : this.offsetx;
        this.posy = window.mouse.y;
        this.posy += this.pointerDirection === 2 ? -this.offsety : this.offsety;

        if (this.pointerDirection === 3)
          this.posx -= this.$el.getBoundingClientRect().width;
        if (this.pointerDirection === 2)
          this.posy -= this.$el.getBoundingClientRect().height;
      }
      if (isNaN(this.posx) || isNaN(this.posy)) {
        this.posx = window.mouse.x + this.offsetx;
        this.posy = window.mouse.y + this.offsety;
      }
      if (
        this.$el.getBoundingClientRect().width + this.posx >
        window.innerWidth
      )
        this.posx =
          window.innerWidth - this.$el.getBoundingClientRect().width - 5;
      if (
        this.$el.getBoundingClientRect().height + this.posy >
        window.innerHeight
      )
        this.posy =
          window.innerHeight - this.$el.getBoundingClientRect().height - 5;
      if (this.posx < 5) this.posx = 5;
      if (this.posy < 5) this.posy = 5;
      requestAnimationFrame(function () {
        view.show = true;
      });
    },
    Init(config) {
      this.header = "";
      this.expanded = false;
      this.show = false;
      for (var x in this.defaultSettings) {
        this[x] = this.defaultSettings[x];
      }

      for (var y in config) {
        if (Object.keys(this).indexOf(y) > -1) this[y] = config[y];
      }
      var view = this;
      requestAnimationFrame(function () {
        if (config.currentComponent === "datafill")
          view.$refs.component.Init(
            config.header,
            config.data,
            config.onceSelected,
            view
          );
        //view.Reposition();
      });

      this.items = config.items;
      this.Toggle();
    },
    SelectItem($event, item) {
      var event = $event;
      var dropdown = this;
      this.selectedItem = item;
      this.toggled = this.remainAfterSelect;
      if (this.selectCallback) {
        this.selectCallback($event, item, dropdown);
      }
      if (item.selectCallback) {
        item.selectCallback($event, item, dropdown);
      }
      this.$forceUpdate();
    },
    loadItems(itemsNew) {
      this.items = itemsNew;
    },
    HandleCustomEvent($event) {
      if (this.customEventHandler) {
        this.customEventHandler($event);
      }
      this.toggled = this.remainAfterSelect;
    },
    Toggle($event) {
      if (this.GetLockedStatus()) return;
      if ($event && $event.currentTarget) {
        if (
          window.mouse.x > this.$el.getBoundingClientRect().left &&
          window.mouse.x < this.$el.getBoundingClientRect().right &&
          window.mouse.y > this.$el.getBoundingClientRect().top &&
          window.mouse.y < this.$el.getBoundingClientRect().bottom
        )
          return;
      }
      var view = this;
      view.toggled = !view.toggled;
      requestAnimationFrame(function () {
        if (view.elRelative) return;
        var box = view.$el.getBoundingClientRect();
        if (view.pointerDirection == 1) {
          if (view.pointerOffset > box.height - 20)
            view.pointerOffset = box.height - 20;
          if (view.pointerOffset < 20) view.pointerOffset = 20;
        } else if (view.pointerDirection == 3) {
          if (view.pointerOffset > box.height - 20)
            view.pointerOffset = box.height - 20;
          if (view.pointerOffset < 20) view.pointerOffset = 20;
        } else if (view.pointerDirection == 2) {
          if (view.pointerOffset > box.width - 20)
            view.pointerOffset = box.width - 20;
          if (view.pointerOffset < 20) view.pointerOffset = 20;
        } else {
          if (view.pointerOffset > box.width - 20)
            view.pointerOffset = box.width - 20;
          if (view.pointerOffset < 20) view.pointerOffset = 20;
        }
      });
      requestAnimationFrame(function () {
        if (view.componentState && view.componentState.type === "timebar") {
          if (view.toggled) view.$refs.component.Init();
          else view.$refs.component.$refs.overlay.toggled = false;
        }
        if (view.componentState && view.componentState.type === "datafill") {
          if (!view.toggled) view.$refs.component.entries = [];
        }
        if (!view.toggled) {
          view.$emit("on-close", view);
        }
      });
      if (this.parentCallback) this.parentCallback();
    },
  },
};
</script>

<style scoped>
.c-dropdown-container {
  z-index: 1000;
  max-height: 96%;
  box-shadow: 4px 4px 5px 3px rgba(0, 0, 0, 0.2), 0 0 0 1px var(--contrast-3);
  border-radius: 0;
  padding: 0;
  max-height: calc(100vh - 20px);
}

.container-body {
  background: var(--bg);
  position: relative;
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: calc(100vh - 20px);
}

.c-dropdown-container .background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
}

.c-dropdown-container > .header {
  width: 100%;
  height: 40px;
  display: block;
}

.c-dropdown-container.list {
  background: var(--bg);
}

.nightmode .dropdown-container {
  background: var(--sub-menu);
}

.c-dropdown .pointer {
  position: absolute;
  top: -7px;
  left: 225px;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #959595;
}

.c-dropdown:not(.list) .pointer:before {
  content: "";
  position: absolute;
  top: 2px;
  left: -5px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #ebebeb;
}

.c-dropdown .pointer.up {
  top: -7px;
  left: 15px;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid var(--contrast-2);
}

.c-dropdown:not(.list) .pointer.up:before {
  top: 2px;
  left: -5px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid white;
}

.c-dropdown .pointer.right {
  left: initial;
  right: -7px;
  right: -19px;
  top: 15px;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-left: 7px solid var(--contrast-2);
}

.c-dropdown:not(.list) .pointer.right:before {
  left: initial;
  top: -5px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid white;
}

.c-dropdown .pointer.down {
  top: initial;
  border-bottom: none;
  bottom: -7px;
  left: 15px;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid var(--contrast-2);
}

.c-dropdown:not(.list) .pointer.down:before {
  top: initial;
  border-bottom: none;
  bottom: 2px;
  left: -5px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid white;
}

.c-dropdown .pointer.left {
  left: -14px;
  top: 15px;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-right: 7px solid var(--contrast-2);
}

.c-dropdown:not(.list) .pointer.left:before {
  left: -4px;
  top: -6px;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid white;
}

.item {
  position: relative;
  display: block;
  height: 20px;
  text-align: left;
  font-size: 11px;
  padding: 0 10px;
  cursor: pointer;
  -webkit-transition: 0.2s;
  transition: 0.2s;
  background: var(--bg);
  overflow: hidden;
  color: var(--contrast-4);
  align-items: center;
}

.container {
  overflow: hidden;
}

.item * {
  pointer-events: none;
  float: left;
  min-height: 15px;
  margin-top: -3px;
  overflow: hidden;
  line-height: 200%;
}

.item .fas {
  margin-right: 10px;
}

.item *:first-child {
  margin-top: 1px;
}

.item:hover,
.item.selected {
  background: var(--contrast-3);
}

.show {
  display: inline-block;
}

.checkbox {
  float: right;
  margin-left: 5px;
  top: 0;
  bottom: 0;
  margin-right: -5px !important;
  right: 5px;
  margin-top: 4px !important;
  min-height: initial;
  height: 12px;
  width: 12px;
  font-size: 12px;
  line-height: 100%;
  border-radius: 100px;
}

.icons-left .checkbox {
  float: left;
  margin-right: 5px !important;
  margin-left: -5px !important;
  left: 5px;
  right: initial;
}

.checkbox.true {
  color: var(--mp);
}

.checkbox.false {
  color: rgba(0, 0, 0, 0);
  background: var(--contrast-2);
  box-shadow: none;
  border-radius: 100px;
}

.item:nth-child(even) .checkbox.false {
  background: var(--contrast-1);
}

.dropdown-search {
  width: 180px;
  margin: 0 10px;
}

.dropdown-search .items {
  width: 180px;
}

.c-dropdown-container.expanded .container-body {
  padding: 50px;
  background: var(--bg);
}

.nightmode .c-dropdown-container.expanded {
  background: var(--bg);
}

.expanded .item {
  margin-left: 35px;
  background-color: var(--mp);
  padding: 4px 10px;
  border-radius: 20px;
  color: #fff;
  cursor: pointer;
  -webkit-transition: background-color 1000ms linear;
  transition: background-color 1000ms linear;
  -webkit-transition: color 1000ms linear;
  transition: color 1000ms linear;
  height: 26px;
  margin-bottom: 5px;
  margin-left: 0;
  line-height: 100%;
}

.expanded .item .label {
  color: white;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  margin-left: 30px;
}

.expanded .item .checkbox {
  width: 18px;
  height: 18px;
  color: white;
  font-size: 18px;
  margin: 0 !important;
  /*background: rgb(255,255,255);
        background: radial-gradient(circle,  rgba(255,255,255,1) 0%, rgba(255,255,255,1) 60%, rgba(255,255,255,0) 60%, rgba(255,255,255,0) 100%);*/
}

.expanded .header {
  position: relative;
  display: inline-block;
  margin-bottom: 20px;
  box-shadow: inset 0 -2px 0 -1px var(--contrast-3);
  width: 100%;
  padding-bottom: 10px;
}

.header .label {
  padding-left: 30px;
}

.expanded .header .label {
  margin-right: 60px;
  font-family: DistrictProBold;
  padding: 0;
  font-size: 25px;
  margin-top: -3px;
}

.item.header {
  background: none;
  text-align: left;
  color: var(--mp);
  pointer-events: none;
  margin-top: 10px;
  margin-bottom: 10px;
  height: 30px;
  font-weight: 600;
}

.item.header .label {
  color: var(--mp);
  margin-left: initial;
  line-height: 25px;
  font-weight: initial;
}

.fa-stack.cancel {
  cursor: pointer;
  position: absolute;
  top: 6px;
  right: 5px;
  font-size: 10px;
  transform: scale(1);
}

.fa-stack.cancel .fa-circle {
  color: transparent;
  font-size: 22px;
  transform: translateY(2px);
}

.fa-stack.cancel .fa-times {
  font-size: 16px;
  transform: translateY(5px);
  color: var(--contrast-3);
}

.fa-stack.cancel:hover .fa-circle {
  color: var(--contrast-3);
}

.fa-stack.cancel:hover .fa-times {
  color: white;
}

.c-dropdown.centered {
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  margin: auto;
  height: fit-content;
}

.c-dropdown.scrolling .component {
  overflow: auto;
  height: calc(100% - 66px);
}

.c-dropdown.no-scrolling {
  overflow: initial;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  padding: 4px 4px 4px 0px;
}

::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}

::-webkit-scrollbar-thumb {
  background: var(--bg);
  border: 0px none var(--bg);
  border-radius: 50px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--bg);
}

::-webkit-scrollbar-thumb:active {
  background: var(--bg);
}

::-webkit-scrollbar-track {
  background: var(--bg);
  border: 0px none var(--bg);
  border-radius: 50px;
}

::-webkit-scrollbar-track:hover {
  background: var(--bg);
}

::-webkit-scrollbar-track:active {
  background: var(--bg);
}

::-webkit-scrollbar-corner {
  background: transparent;
}

.tab-body {
}

.tab-header {
}

.c-dropdown .container-body > .tab-header .label {
  text-align: center;
  color: var(--contrast-4);
  font-size: 18px !important;
  font-family: DistrictProBook;
  border: var(--contrast-2) solid 1px;
  border-bottom: none;
  padding: 5px 10px;
  height: 40px;
  margin: 0 5px;
  transition: 0.2s;
  cursor: pointer;
}

.c-dropdown .container-body > .tab-header .label:hover,
.c-dropdown .container-body > .tab-header .label.selected {
  background: var(--mp);
  color: white;
}

.c-dropdown .container-body > .tab-header .label:hover,
.c-dropdown .container-body > .tab-header .label.selected {
  background: var(--mp);
  color: white;
}

.c-dropdown.index-override {
  z-index: 100000000;
}
.c-dropdown.tooltip {
  z-index: 100000001;
  border-radius: 0;
  pointer-events: none;
  padding: 5px 10px;
  overflow: hidden;
}
.c-dropdown.tooltip .container-body {
  overflow: hidden;
}
.c-dropdown.tooltip .container-body > .cancel {
  display: none;
}
.c-dropdown.tooltip .container-body > .header {
  height: initial;
  width: initial;
  padding: 0;
}
.c-dropdown.tooltip .container-body > .header > .label {
  font-size: 12px;
  font-weight: 700;
  color: var(--contrast-4);
  padding: 0;
}

.c-dropdown.list-thick {
  background: var(--bg);
  padding: 0;
  border-radius: 0;
}

.c-dropdown.list-thick .container-body > .cancel {
  display: none;
}

.c-dropdown.list .container-body {
  overflow-y: hidden;
}

.c-dropdown.drag-container {
  pointer-events: none;
}

.c-dropdown.drag-container .container-body {
  overflow: hidden;
}

.c-dropdown.locked {
}

.c-dropdown.locked .background {
  background: rgba(0, 0, 0, 0.5);
}

.c-dropdown.locked .fa-stack.cancel {
  display: none;
}

.c-dropdown.allow-overflow,
.c-dropdown.allow-overflow .container-body {
  overflow: visible;
}
</style>
